import { useState } from "react";
import { Grid2 as Grid, Typography } from "@mui/material";
import { SearchButton } from "./SearchButton";
import { useStyles } from "../../Search.styles";
import { SearchInput } from "./SearchInput";
import { searchHelperText } from "../../constants";
type SearchBarProps = {
	helperText?: string;
	clearAfterSearch?: boolean;
	handleSearch: (value: string) => Promise<void> | void;
};

export const SearchBarContainer = ({ helperText, clearAfterSearch, handleSearch }: SearchBarProps) => {
	const classes = useStyles();
	const [searchText, setSearchText] = useState("");
	const [isSearchTypeText, setIsSearchTypeText] = useState(false);

	const onTextChange = (event) => {
		setSearchText(event.target.value.toString());
	};

	const onChangeSearchType = (event, nextView) => {
		setIsSearchTypeText(nextView);
	};

	const onSearch = async () => {
		handleSearch(searchText);
		if (clearAfterSearch) {
			setSearchText("");
		}
	};
	return (
		<Grid container direction="column" className={classes.container}>
			<Grid container direction="row">
				<SearchInput
					searchText={searchText}
					isSearchTypeText={isSearchTypeText}
					onTextChange={onTextChange}
					onSearch={onSearch}
					onChangeSearchType={onChangeSearchType}
				/>
				<SearchButton onSearch={onSearch} />
			</Grid>
			<Grid>
				<Typography variant="caption" className={classes.searchHelperText}>
					{helperText ? helperText : searchHelperText.general}
				</Typography>
			</Grid>
		</Grid>
	);
};
